// Msal imports
import { useState, useEffect } from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";

// import { Navigate } from "react-router-dom";
// import { msalInstance } from "../../index";
import { useIsAuthenticated } from "@azure/msal-react";

const ProtectedRoute = ({ children }) => {
  const authRequest = {
    ...loginRequest,
  };

  let isAuthenticated = useIsAuthenticated();
  const [isAuthenticatedSAFY, setIsAuthenticatedSAFY] = useState(null);

  useEffect(() => {
    // console.log(
    //   "Protected Route Authentication",
    //   isAuthenticated,
    //   isAuthenticatedSAFY
    // );
    if (isAuthenticated) {
      const checkAuthentication = async () => {
        const safyInfo = localStorage.getItem("safyInfo");
        if (safyInfo?.length > 0) {
          setIsAuthenticatedSAFY(true);
          // console.log("Authenticated", isAuthenticatedSAFY);
        } else {
          console.log("Refreshing");
          setTimeout(() => {
            setIsAuthenticatedSAFY(false);
            checkAuthentication();
          }, 1000);
        }
      };

      checkAuthentication();
    }
  }, [isAuthenticated, isAuthenticatedSAFY]);

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
    >
      {isAuthenticated && isAuthenticatedSAFY === true && children}
    </MsalAuthenticationTemplate>
  );
  // const isAuthenticated = useIsAuthenticated();
  // const activeAccount = msalInstance.getActiveAccount();
  // const token = activeAccount?.idTokenClaims;

  // if (!isAuthenticated) {
  //   console.log("failed is Authenticated");
  //   return <Navigate replace to="/" />;
  // }

  // const difference = (token.exp * 1000 - Date.now()) / 1000;

  // // const token = getAccessToken(config.scopes);
  // // console.log("PRoute Token", token);
  // return difference > 0 ? children : <Navigate replace to="/" />;
};

export default ProtectedRoute;
